export default __webpack_public_path__ + "static/media/phone-in-hand.4ea73d51.png";